import ResourceTagList from './ResourceTagList';

import "./ResourceTagList.scss";

export * from './ResourceTagList.types';

export { ResourceTagList };

